var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.5 12a2.5 2.5 0 0 1 2.398 1.791l-.013-.042 8.365.001v1.5H8.885l.013-.042a2.501 2.501 0 0 1-4.796 0l.013.043-1.365-.001v-1.5h1.365l-.013.041A2.501 2.501 0 0 1 6.5 12Zm0 1.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm7-6a2.5 2.5 0 0 1 2.398 1.791l-.013-.042 1.365.001v1.5h-1.365l.013-.042a2.501 2.501 0 0 1-4.796 0l.013.043-8.365-.001v-1.5h8.365l-.013.041A2.501 2.501 0 0 1 13.5 7.5Zm0 1.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-7-6a2.5 2.5 0 0 1 2.398 1.792l-.013-.043 8.365.001v1.5H8.885l.013-.042a2.501 2.501 0 0 1-4.796 0l.013.043L2.75 6.25v-1.5l1.365-.001-.013.043A2.501 2.501 0 0 1 6.5 3Zm0 1.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.3789e471a91df406922565fee88a023b.svg";
export { ForwardRef as ReactComponent };